import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://deuroapps.eu";
const HOME_TITLE = "Deuro App | Rete di scambio di beni e servizi";
const HOME_DESCRIPTION = "Scopri Deuro, la piattaforma e app di scambio per offrire e trovare servizi, prodotti e competenze nella tua comunità.";

const ROUTES = {
  "/accedi": {
    title: "Accedi a Deuro",
    description: "Accedi al tuo account Deuro.",
    robots: "noindex,follow",
  },
  "/registrati": {
    title: "Registrati su Deuro",
    description: "Crea il tuo profilo sulla rete di scambio Deuro.",
    robots: "noindex,follow",
  },
};

const setMeta = (name, content) => {
  const element = document.head.querySelector(`meta[name="${name}"]`);
  if (element) element.setAttribute("content", content);
};

export const SeoManager = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const home = pathname === "/";
    const route = ROUTES[pathname];
    document.title = home ? HOME_TITLE : (route?.title || "Deuro");
    setMeta("description", home ? HOME_DESCRIPTION : (route?.description || "Area riservata Deuro."));
    setMeta("robots", home ? "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1" : (route?.robots || "noindex,nofollow"));

    const canonical = document.head.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", home ? `${SITE_URL}/` : `${SITE_URL}${pathname}`);
  }, [pathname]);

  return null;
};